// extracted by mini-css-extract-plugin
export default {"link":"index_link__8ILWW"};